export const enum DrawerAnchor {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
}
